<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container>
      <a-form :form="form" slot="detail">
        <a-row>

          <a-col :span="24">
            <a-form-item label="班级名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                show-search
                :default-active-first-option="false"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                v-model="model.classId"
                placeholder="请选择班级"
                @search="handleClassSearch"
                @change="handleClassChange"
                allowClear
              >
                <a-select-option v-for="d in classData" :key="d.id">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="老师名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                show-search
                :default-active-first-option="false"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                v-model="model.teacherId"
                placeholder="请选择老师"
                @search="handleUserSearch"
                @change="handleUserChange"
                allowClear
              >
                <a-select-option v-for="d in userData" :key="d.id">
                  {{ d.realname }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>
import { httpAction, getAction } from '@/api/manage'
import pick from 'lodash.pick'
import { validateDuplicateValue } from '@/utils/util'
import JFormContainer from '@/components/jeecg/JFormContainer'
import JDate from '@/components/jeecg/JDate'
import Vue from "vue";
import {TENANT_ID} from "@/store/mutation-types";

export default {
  name: 'TeacherClassForm',
  components: {
    JFormContainer,
    JDate
  },
  data() {
    return {
      form: this.$form.createForm(this),
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: '/aigoes/teacherClass/add',
        edit: '/aigoes/teacherClass/edit',
        queryById: '/aigoes/teacherClass/queryById'
      },
      classData: [],
      userData: []
    }
  },
  created() {

  },
  methods: {
    add() {
      this.edit({})
    },
    edit(record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'classId',
            'className',
            'teacherId',
            'teacherName',
            'relation',
            'createBy',
            'createTime',
            'updateBy',
            'updateTime'
          )
        )
      })
      this.handleClassSearch("", this.model);
      this.handleUserSearch("", this.model);
    },
    submitForm() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'put'
          }
          let formData = Object.assign(this.model, values)
          httpAction(httpurl, formData, method)
            .then(res => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    },
    /**
     * 查询班级
     * @param val
     * @param name
     */
    handleClassSearch(val, initData){
      getAction("/aigoes/schoolClass/list", {'name': val}).then(res => {
        this.classData = res.result.records
        if(initData.classId){
          this.classData.push({"id": initData.classId, "name": initData.className})
        }
      })
    },
    /**
     * 选择
     * @param value
     */
    handleClassChange(val) {
      this.classData.forEach(item => {
        if(item.id === val){
          this.model.className = item.name;
        }
      })
    },
    /**
     * 查询老师
     * @param val
     * @param name
     */
    handleUserSearch(val, initData){
      getAction("/sys/user/list", {'realname': '*'+val+'*','userIdentity_FindInSet': '3','relTenantIds_FindInSet':Number(Vue.ls.get(TENANT_ID))}).then(res => {
        this.userData = res.result.records
        if(initData.teacherId){
          this.userData.push({"id": initData.teacherId, "realname": initData.teacherName})
        }
      })
    },
    /**
     * 选择老师
     * @param value
     */
    handleUserChange(val) {
      this.userData.forEach(item => {
        if(item.id === val){
          this.model.teacherName = item.realname;
        }
      })
    }
  }
}
</script>